export enum EmployeeRoleId {
  CREDENTIALING_ANALYST = 102,
  RECRUITER = 46,
  CUSTOMER_SUPPORT_PAYROLL = 142,
}
